import src from "IMAGE";
export default { src, width: 720, height: 1484, blurWidth: 0, blurHeight: 0};
